import { baseUrl } from "../shared/api";

export function businessTrustPass(userId, businessTrustPassId) {
  return `${baseUrl()}/api/v2/users/${userId}/business_trustpasses/${businessTrustPassId}`;
}

export function resolveNotifications(userId, type, id) {
  return `${baseUrl()}/api/v2/users/${userId}/${type}/${id}/resolve_resubmit_fca_notifications`;
}



// WEBPACK FOOTER //
// ./src/features/trustpass/apiUrls.js